import { IJsonQuery } from '../../types/jsonQuery/jsonQuery';

type TNonNullable<T> = Exclude<T, null>;

type TPartialJsonQuery = {
  [key in keyof IJsonQuery]: TNonNullable<IJsonQuery[key]>;
};

export const removeEmptyKeys = (jsonQuery: IJsonQuery): TPartialJsonQuery => {
  const result: TPartialJsonQuery = {};
  const jsonQueryKeys = Object.keys(jsonQuery) as (keyof IJsonQuery)[];

  const keyMapper = <Key extends keyof IJsonQuery>(key: Key) => {
    if (jsonQuery[key]) {
      result[key] = jsonQuery[key] as TPartialJsonQuery[Key];
    }
  };

  jsonQueryKeys.forEach(keyMapper);

  return result;
};
